import { render, staticRenderFns } from "./ModalViewLocalidad.vue?vue&type=template&id=45038160&scoped=true&"
import script from "./ModalViewLocalidad.vue?vue&type=script&lang=ts&"
export * from "./ModalViewLocalidad.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViewLocalidad.vue?vue&type=style&index=0&id=45038160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45038160",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('45038160', component.options)
    } else {
      api.reload('45038160', component.options)
    }
    module.hot.accept("./ModalViewLocalidad.vue?vue&type=template&id=45038160&scoped=true&", function () {
      api.rerender('45038160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorLocalidad/ModalViewLocalidad.vue"
export default component.exports